export default "__VITE_ASSET__DlYNXSRO__"